.questions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem;

  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

@media (width < 500px) {
  .questions {
    padding: 1rem;
    gap: 1rem;
  }
}

.questions header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  font-weight: bold;
  font-size: 2rem;
}

@media (width < 500px) {
  .questions header {
    font-size: 1.35rem;
  }
}

.questions h1 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.icons {
  width: 40px;
}

@media (width < 500px) {
  .icons {
    width: 30px;
  }
}

.question-text {
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
}

@media (width < 500px) {
  .question-text {
    font-size: 1.35rem;
  }
}

.options-list {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
}

@media (width < 500px) {
  .options-list {
    gap: 0.5rem;
  }
}

.options-list label {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  font-size: 1.25rem;

  cursor: pointer;
}

@media (width < 500px) {
  .options-list label {
    gap: 0.5rem;
    font-size: 1rem;
  }
}

.options-list input[type="radio"] {
  appearance: none;
  display: flex;
  padding: 0.25rem;

  border: 4px solid black;
  border-radius: 100%;

  cursor: pointer;
}

.options-list input[type="radio"]::before {
  content: "";
  padding: 0.5rem;

  background-color: black;
  border-radius: 100%;

  transform: scale(0);
  transition: 150ms ease-in-out;
}

.options-list input[type="radio"]:checked::before {
  transform: scale(1);
}

.buttons-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding-top: 2rem;
}

@media (width < 500px) {
  .buttons-container {
    gap: 0.5rem;
    padding-top: 1rem;
  }
}

.buttons-container button {
  padding: 0.75rem;

  border-radius: 100%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: black;
  border: 1px solid lightslategray;
  color: white;

  cursor: pointer;
}

.buttons-container button[type="submit"] {
  border-radius: 10px;
}

.buttons-container button:disabled {
  background-color: transparent;
  border: 1px solid lightslategray;
  color: lightslategray;

  cursor: not-allowed;
}

.buttons-container img {
  width: 30px;
}

@media (width < 500px) {
  .buttons-container img {
    width: 25px;
  }
}

.buttons-container button:disabled img {
  filter: grayscale(100%);
  opacity: 50%;
}
